




window.setExportInProgress = function( examId , isPractice, isExported ) {

    "use strict";
    getEl( "exportBtn_"+ examId ).disabled = 1;
    if ( isPractice !== "yes" && isExported !== "yes" ) {
        window.expWarnPanel.show();
    }
}


window.pauseResume = function(btnEl,examId, pId, action) {

    "use strict";
    window.YAHOO.util.Dom.addClass(btnEl,"btnWait");
    var url = "exam-pause-resume.async.php?exam_id=" + examId + "&participant_id=" + pId + "&action=" + action + "&_token=" + csrf_token;
    window.YAHOO.util.Connect.asyncRequest ("POST",url, {
        success: function (o) {
            window.YAHOO.util.Dom.removeClass(btnEl,"btnWait");
            window.syncWithServer();
        },
        failure: function (o) {
            alert (o.responseText);
        }
    });
}


window.displayResults = function( examId, pId ) {

    "use strict";
    window.location="exam-result-details.php?exam_id=" + examId + "&p_id=" + pId + "&src=monitor";
}


/**
 * Export the exam result for an individual participant
 * @param int examId
 * @param int pId
 * @param string isPractice
 */
window.exportSingleResult = function( examId, pId, isPractice ) {

    "use strict";
    setExportInProgress( examId, isPractice, "no" );
    window.location="exam-export.php?exam_id=" + examId + "&participant_id=" + pId + "&action=export";
    return true;
}


window.changeName = function(examId, pId) {

    "use strict";
    window.location="exam-update-participant.php?exam_id=" + examId + "&participant_id=" + pId;
}

window.sessionPreviewCheck = function(exam){
    var warning_element = $('#session-preview-warning');
    var is_warning_shown = $('#session-preview-warning').hasClass('show');

    if(exam._ssprv && !is_warning_shown){
        warning_element.collapse('show');
    } else if (!exam._ssprv && is_warning_shown){
        warning_element.collapse('hide');
    }
}
window.disablePreviewMode = function(){
    $.ajax({
        method: "POST",
        url: "preview-status-unset.async.php",
        dataType: "json",
    })
    .done(function( is_success ) {
        if(!is_success){
            alert('ERROR: failed to disable Preview Mode')
        }
    });
}
window.updateMonitor = function(exams) {

    "use strict";
    var i, j, k, nPrelim, exam;

    var participants =[];
    var allPaused = true;
    var allResumed = true;
    var anySubmitted = false;
    var p;
    var csvDlBtnEl, liEl, bcEl, psEl, suEl, asEl, hbEl, ckEl;
    var ckElId;

    sessionPreviewCheck(exams[0]);

    for (i = 0; i < exams.length-1; i++) {

        exam = exams[i];

        // Ignore this exam if it's not on the display
        if (getEl("exam_header_" + exam.id) === null) {
            continue;
        }

        $("#startAllBtn_"+exam.id).prop('disabled', exam.status!==0);
        $("#stopAllBtn_"+exam.id).prop('disabled', exam.status!==1);
        $("#pauseAllBtn_"+exam.id).prop('disabled', exam.status!==1);
        $("#resumeAllBtn_"+exam.id).prop('disabled', exam.status!==1);
        $("#addTimeAllBtn_"+exam.id).prop('disabled', exam.status!==1);

        if ( !cfg.UNPROCTORED && !cfg.LOGIN_SHEETS_NEVER_DISABLED ) {
            if ( cfg.PRIV_SHOW_LOGIN_SHEETS ) getEl("loginSheetsBtn_"+exam.id).disabled = (exam.status!==0);
            else                              getEl("loginSheetsBtn_"+exam.id).disabled = true;

            if ( getEl("lateParticipantsBtn_"+exam.id) !== null )  getEl("lateParticipantsBtn_"+exam.id).disabled = (exam.status!==0);
            if ( getEl("mailLoginBtn_"+exam.id) !== null )  getEl("mailLoginBtn_"+exam.id).disabled = (exam.status!==0);
        } else {
            if ( cfg.PRIV_SHOW_LOGIN_SHEETS ) getEl("loginSheetsBtn_"+exam.id).disabled = !(exam.status !== 2 );
            else                              getEl("loginSheetsBtn_"+exam.id).disabled = true;

            if ( getEl("lateParticipantsBtn_"+exam.id) !== null )  getEl("lateParticipantsBtn_"+exam.id).disabled = !(exam.status !== 2 );
            if ( getEl("mailLoginBtn_"+exam.id) !== null )  getEl("mailLoginBtn_"+exam.id).disabled = !(exam.status !== 2 );
        }
        if (cfg.OPTDELETEBUTTON) getEl("deleteBtn_"+exam.id).disabled = (exam.status!==0);

        getEl("resultsBtn_"+exam.id).disabled = (exam.status!==2) || (!cfg.PRIV_SHOW_RESULTS_BTN);

        getEl("analysisBtn_"+exam.id).disabled = (exam.status!==2) || (!cfg.PRIV_SHOW_ANALYSIS_BTN);

        if ( getEl("previewBtn_"+exam.id) !== null ) {
            getEl("previewBtn_"+exam.id).disabled = (exam.status!==0);
        }

        try{
            var oneDayAgo = new Date();
            oneDayAgo.setDate(oneDayAgo.getDate() - 1);

            var date_ = document.getElementById("scheduled_start_"+exam.id).value;
            var schedule_date = Date.parse(date_);


            if ( schedule_date < oneDayAgo ){
                getEl("startAllBtn_"+exam.id).disabled = true;
                console.log("Exam "+exam.id+" scheduled date is in the Past!");
            }
        }catch(err){}


        // Mantis 2092 Restrict access to certain functions for examiner users
        if ( userType === "admin" || !cfg.DISABLE_FUNCTIONS_EXAMINER) {

            // Mantis #1962
            csvDlBtnEl = getEl("csvDlBtn_"+exam.id);
            if (csvDlBtnEl !== null) {
                csvDlBtnEl.disabled = (exam.status!==2);
            }
            // Mantis #1958, #2134
            if ( exam.isPractice === 1 ) {
                if ( cfg.OPTEXPORTBUTTON) getEl("exportBtn_"+exam.id).disabled = 1;
            } else {
                if ( cfg.OPTEXPORTBUTTON) {
                    if ( cfg.PRIV_SHOW_MAN_EXPORT ) getEl("exportBtn_"+exam.id).disabled = (exam.status!==2 && exam.status!==3);
                    else                            getEl("exportBtn_"+exam.id).disabled = true;
                }
            }
            if ( cfg.OPTDELETEBUTTON) getEl( "deleteBtn_"+exam.id ).disabled = ( exam.status !== 0 );
            getEl( "logBtn_" + exam.id ).disabled = 0;

        } else {

            // User Type must be "examiner"
            csvDlBtnEl = getEl("csvDlBtn_"+exam.id);
            if (csvDlBtnEl !== null) {
                csvDlBtnEl.disabled = 1;
            }

            if ( cfg.OPTEXPORTBUTTON) {
                if ( cfg.PRIV_SHOW_MAN_EXPORT ) getEl( "exportBtn_" + exam.id ).disabled = (exam.status!==2 && exam.status!==3);
                else                            getEl( "exportBtn_" + exam.id ).disabled = true;
            }

            getEl( "logBtn_" + exam.id ).disabled = 1;
            if ( cfg.OPTDELETEBUTTON) getEl( "deleteBtn_" + exam.id ).disabled = 1;

        }


        participants = exams[i].participants;

        for (j = 0; j < participants.length; j++) {
            p = participants[j];
            exam = exams[i];
            if (p === null) {
                break;
            }
            // Logged in
            liEl = document.getElementById("li_"+p.id);
            liEl.src = p.li ? indicatorGreen : indicatorGray;
            if ( p.li ) {
                liEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.LOGGEDIN_IND_STR;
            } else {
                liEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.NOT_LOGGEDIN_IND_STR;
            }


            // Change button. Disabed if logged in.
            bcEl = document.getElementById("bc_"+p.id);
            if (exams[i].status === 0) {
                bcEl.disabled = false;
                bcEl.style.visibility = "visible";
            } else {
                bcEl.disabled = true;
                bcEl.style.visibility = "hidden";
            }


            // Preliminaries indicators
            nPrelim = (exam.nPrelim===undefined?6:exam.nPrelim);

            for ( k = 0; k < p.ps.length; k++ ) {

                psEl = document.getElementById("ps"+k+"_"+p.id);
                psEl.src = p.ps[k]===true ? indicatorGreen : indicatorGray;
                if(p.ps[k] === 2) psEl.src = indicatorRed;
                psEl.title = p.ps[k]===true ? cfg.CANDIDATE_STR + " " + p.id + " " + cfg.ACK_SCRN_STR + " " + (k + 1):"";
                if(p.ps[k] === 2)psEl.title = 'Statement invalid for ' + cfg.CANDIDATE_STR + " " + p.id + " on screen " + (k + 1);

            }

            // Submitted
            suEl = document.getElementById("su_"+p.id);
            suEl.src = p.su ? indicatorGreen : indicatorGray;
            if ( p.su ) {
                suEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.SUBMT_STR;
            } else {
                suEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.NOT_SUBMT_STR;
            }


            // Heartbeat and activity indicator are only
            // illuminated when the exam is active and the
            // participant has loggedin and has not yet
            // submitted (or been terminated).

            // Heartbeat
            hbEl = document.getElementById("hb_"+p.id);
            if ( (exam.status===1 || exam.status===0) && (p.li===1) && (p.su===0) ) {
                hbEl.src = hbStatusIndicator[p.hbs];
                if ( p.hbs === 0 ) {
                    hbEl.title = cfg.CAND_DEV_OK_STR + " " + p.id;
                } else if ( p.hbs === 1 ) {
                    hbEl.title = cfg.CAND_DEV_WARN_STR + " " + p.id;
                } else {
                    hbEl.title = cfg.CAND_DEV_PROB_STR + " " + p.id;
                }
            } else {
                hbEl.src = indicatorGray;
                hbEl.title = cfg.CAND_DEV_NO_CONN_STR + " " + p.id + ".\n " + cfg.VALID_LOGGED_IN_ONLY_STR;
            }

            // Activity indicator
            asEl = document.getElementById("as_"+p.id);
            if ( (exam.status===1) && (p.li===1) && (p.su===0) ) {
                asEl.src = hbStatusIndicator[p.as];
                if ( p.as === 0 ) {
                    asEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.ACTIVE_STR;
                } else if ( p.as === 1 ) {
                    asEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.ACTIVE_WARN_STR;
                } else {
                    asEl.title = cfg.CANDIDATE_STR + " " + p.id + " " + cfg.ACTIVE_PROB_STR;
                }
            } else {
                asEl.src = indicatorGray;

            }

            // Enable pause button if clock running
            if (exam.status !== 1 || !p.li || p.su) {
                // pause, resume, stop buttons disabled if exam is not in
                // active state. Mantis 0001947: Disable these buttons also
                // when participant is not logged in or has submitted.
                getEl("bp_" + p.id).disabled = true;
                getEl("br_" + p.id).disabled = true;
                getEl("bs_" + p.id).disabled = true;
                $("#bat_" + p.id).prop('disabled', true);
                getEl("bpi_" + p.id).src = "../assets/pause_gray.png";
                getEl("bri_" + p.id).src = "../assets/resume_gray.png";
                getEl("bsi_" + p.id).src = "../assets/stop_gray.png";
                $(getEl("bati_" + p.id)).addClass('add-time-one-inactive').removeClass('add-time-one-active');
            } else {
                getEl("bp_" + p.id).disabled = ! p.cr;
                getEl("br_" + p.id).disabled = p.cr;
                getEl("bs_" + p.id).disabled = false;
                $("#bat_" + p.id).prop('disabled', false);
                getEl("bpi_" + p.id).src = "../assets/pause"+(p.cr?"":"_gray")+".png";
                getEl("bri_" + p.id).src = "../assets/resume"+(p.cr?"_gray":"")+".png";
                getEl("bsi_" + p.id).src = "../assets/stop"+(p.su?"_gray":"")+".png";
                $(getEl("bati_" + p.id)).removeClass('add-time-one-inactive').addClass('add-time-one-active');
            }

            // Mantis 0002297: Ignore not logged in and submitted participants
            // when checking paused/resumed states
            if ( p.cr && p.li && !p.su ) {
                allPaused = false;
            }
            if ( !p.cr && p.li && !p.su ) {
                allResumed = false;
            }


            ckElId = "ck_" + p.id;
            ckEl = document.getElementById("ck_"+p.id);
            updateClock(p.ck,ckEl);
                        ckEl.cr = p.cr; // clock running
            if ( p.cr === false ) {
                window.YAHOO.util.Dom.addClass(ckEl,"ckPaused");
            } else {
                window.YAHOO.util.Dom.removeClass(ckEl,"ckPaused");
            }

            // Answer count
            updateProgressBar(p.id, p.ac, exams[i].itemCount);


            // Mantis 0002327: Don't display individual Result buttons unless exam is submitted for
            // this participant. Disable the button unless participant logged in and submitted
            if ( !p.su ) {
                getEl("brs_" + p.id).style.display = "none";
            } else {
                getEl("brs_" + p.id).style.display = "inline";
            }

            // Mantis 0002459: Because all exams are submitted when the exam is stopped, can only
            // identify participants that have submitted AND started an exam by looking at the prelim
            // screen state. Needed for enabling/disabling individual results buttons.

            var lastPrelim = p.ps[p.ps.length-1];

            if ( lastPrelim && p.su ) {
                if ( cfg.EARLY_ANALYSIS || exam.status === 2 ) {
                    getEl("brsi_" + p.id).src = "../assets/report_user.png";

                    if ( cfg.PRIV_SHOW_RESULTS_BTN ) getEl("brs_" + p.id).disabled = false;
                    else                             getEl("brs_" + p.id).disabled = true;
                }
            }
            if ( !cfg.EARLY_ANALYSIS ) {
                getEl("brs_" + p.id).setAttribute( "class", "sglResultsBtn" );
                getEl("brs_" + p.id).setAttribute( "className", "sglResultsBtn" );
            }

            // Mantis 0002327: Don't display individual Export buttons unless exam is submitted for
            // this participant AND earlyAnalysis is configured ON.
            // Button should be disabled unless participant actually logged in and submitted.
            if ( !p.su || !cfg.EARLY_ANALYSIS ) {
                getEl("be_" + p.id).style.display = "none";
            } else {
                getEl("be_" + p.id).style.display = "inline";
            }

            if ( lastPrelim &&  p.su ) {
                getEl("bei_" + p.id).src = "../assets/report_go.png";
                getEl("be_" + p.id).disabled = false;
            }


            // Mantis 0002327: Don't display Pause/Resume/Stop buttons if exam is submitted for this participant
            if ( p.su ) {
                getEl("bp_" + p.id).style.display = "none";
                getEl("br_" + p.id).style.display = "none";
                getEl("bs_" + p.id).style.display = "none";
                $("#bat_" + p.id).hide();
            } else {
                getEl("bp_" + p.id).style.display = "inline";
                getEl("br_" + p.id).style.display = "inline";
                getEl("bs_" + p.id).style.display = "inline";
                $("#bat_" + p.id).show();
            }

            if ( p.su ) {
                anySubmitted = true;
            }


        } // next participant

        if ( exam.status === 1 ) {
            if ( allResumed ) {
                getEl("resumeAllBtn_"+exam.id).disabled  = 1;
            }
            if ( allPaused ) {
                getEl("pauseAllBtn_"+exam.id).disabled = 1;
            }
        }

        // Mantis 0002327: Enable the Results and analysis buttons once at least
        // one participant has submitted
        if ( anySubmitted && cfg.EARLY_ANALYSIS ) {
            if ( cfg.PRIV_SHOW_RESULTS_BTN  ) getEl( "resultsBtn_" + exam.id ).disabled  = false;
            else                              getEl( "resultsBtn_" + exam.id ).disabled  = true;

            if ( cfg.PRIV_SHOW_ANALYSIS_BTN ) getEl( "analysisBtn_" + exam.id ).disabled = false ; // Eeek 0 is false in JavaScript hence this enables the button!
            else                              getEl( "analysisBtn_" + exam.id ).disabled = true; // i.e. disable it!
        }

    } // next exam
}

/**
 * Synchronize countdown clocks with server.
 */
window.syncWithServer = function() {

    "use strict";
    // Mantis 0002243: pass filter argument to status update so only load filtered exam!
    // Chrome's aggressive caching causes problems here - if server cannot process AJAX call
    // the first time (perhaps because it's busy?), Chrome assumes the URL can never be
    // reached. Hence add the time to ensure the URL differs on each call.
    var filter = getRequestParameters().filter;

    window.YAHOO.util.Connect.asyncRequest("GET","get-exam-status.async.php?filter=" + filter + "&time=" + (new Date().getTime()), {
        success: function (o) {
            var exams = window.YAHOO.lang.JSON.parse(o.responseText);
            updateMonitor(exams);
        },
        failure: function (o) {
        }
    });
}


/**
 * Get the user level of the logged in user from the server
 * Introduced in response to Mantis 0002092.
 */
window.getLoggedInUserType = function() {

    "use strict";
    window.YAHOO.util.Connect.asyncRequest("GET","get-user-type.async.php", {
        success: function (o) {
            // Set the global variable defining the user level here...
            userType = ( window.YAHOO.lang.JSON.parse( o.responseText ) ).userType;
        },
        failure: function (o) {
        }
    });
}

window.updateClocks = function() {

    "use strict";
    var els = window.YAHOO.util.Dom.getElementsByClassName("ck");
    var i, ck;
    for (  i = 0; i < els.length; i++ ) {
        ck = els[i].innerHTML | 0;
        if ( ck > 0 && (els[i].cr === true ) ) {
            //els[i].innerHTML = ck-1;
            updateClock(ck-1,els[i]);
        }
    }
}


/**
 * Write into the clock element the remaining time formatted as mmm:ss.
 * @param clockTime int Clock time in seconds.
 * @param clockEl HTML DOM element into which to write the time
 */
window.updateClock = function(clockTime,clockEl) {

    "use strict";
    var hours, minutes, seconds, minStr, timeStr;

    if (clockTime === null){
        return;
    }

    if (clockTime < 0) {
        clockTime=0;
    }

    if ( cfg.UNPROCTORED ) {
        hours = (clockTime / 3600) | 0;
        minutes = ( (clockTime / 60) - (hours* 60) ) | 0;
        seconds = (clockTime % 60);

        if ( minutes === 0 ) {
            minStr = "00";
        } else if ( minutes < 10 ) {
            minStr = "0" + minutes;
        } else {
            minStr = minutes;
        }
        timeStr = ( hours > 0 ? hours + " : " : "" )
            + minStr + " : "
            + (seconds < 10 ? "0"+seconds : seconds);

    } else {
        minutes = (clockTime / 60) | 0;
        seconds = (clockTime % 60);
        timeStr = (minutes < 10 ? "0" + minutes : minutes)
            + " : "
            + (seconds < 10 ? "0"+seconds : seconds);
    }
    clockEl.innerHTML = timeStr;
}

window.updateProgressBar = function(pId, val, maxVal) {

    "use strict";
    var pbEl = document.getElementById("acpb_" + pId);
    var bEl = document.getElementById("acb_" + pId);
    var w = (val * pbEl.clientWidth / maxVal)|0;
    bEl.style.width= w + "px";
    bEl.innerHTML = val + "/" + maxVal;
}
window.getEl = function(elId) {

    "use strict";
    return document.getElementById(elId);
}
window.updateWallClock = function() {

    "use strict";
    var now=new Date();
    var h=now.getHours();
    var m=now.getMinutes();
    var s=now.getSeconds();
    // Time is HH:mm:ss
    var time=(h<10?"0"+h:""+h)+":"+(m<10?"0"+m:""+m)+":"+(s<10?"0"+s:""+s);

    var y=now.getFullYear();
    var mth=now.getMonth()+1;
    var d=now.getDate();
    // Date is yyyy-MM-dd
    var date=y+"-"+(mth<10?"0"+mth:""+mth)+"-"+(d<10?"0"+d:""+d);

    getEl("wallClock").innerHTML=date + " " + time;
}


/**
 * Returns the GET parameters from the window.
 * (See http://stackoverflow.com/a/5448635)
 * Introduced in response to Mantis 0002243.
 * @returns string
 */
window.getRequestParameters = function() {

    "use strict";
    var prmstr = window.location.search.substr(1);
    var prmarr = prmstr.split ("&");
    var params = {};
    var i, tmparr;

    for ( i = 0; i < prmarr.length; i++) {
        tmparr = prmarr[i].split("=");
        params[tmparr[0]] = tmparr[1];
    }
    return params;
}

var Elbtn_wait_anim_stop = false;
window.sendEmailLogins = function(Elbtn, examId, csrf_token) {
    "use strict";
    if(!confirm('Credentials are about to be sent to Participants.\nPlease confirm.')) return false;

    var btnValue = Elbtn.value;
    waitButtonAnimation(Elbtn);
    Elbtn.disabled = true;
    var url = "send-mail-login.async.php?exam_id=" + examId + "&_token=" + csrf_token;
    window.YAHOO.util.Connect.asyncRequest ("POST",url, {
        success: function (o) {
            Elbtn.disabled = false;
            Elbtn_wait_anim_stop = true;
            Elbtn.value = btnValue;
            alert (o.responseText);
        },
        failure: function (o) {
            Elbtn.disabled = false;
            Elbtn_wait_anim_stop = true;
            Elbtn.value = btnValue;
            alert (o.responseText);
        }
    });
}
window.waitButtonAnimation = function(elem) {
    var i = 0;
    var id = setInterval(frame, 60);
    var text_loop = "           •••           ".split('');

    function frame() {
        if (Elbtn_wait_anim_stop) return;
        if (i == (text_loop.length - 1)) i = 0;
        else i++;
        text_loop.move(-1,0);
        elem.value = text_loop.join("").substring(0,text_loop.length / 3 * 2 );
    }
}
Array.prototype.move = function (from, to) {
  this.splice(to, 0, this.splice(from, 1)[0]);
};
window.startPreviewExam = function(text,exam_id){
    window.open('exam-preview.php?exam_id='+exam_id);

    return false;
}
